<template>
  <v-row>
    <v-col :cols="tipoDeCanalSelecionadoIdLocale ? 6 : 12">
      <v-select
        v-model="tipoDeCanalSelecionadoIdLocale"
        dense
        outlined
        validate-on-blur
        label="Tipo do canal de envio"
        placeholder="Tipo do canal de envio"
        item-text="nome"
        item-value="id"
        no-data-text="Nenhum canal disponível"
        :clearable="!readonly"
        :readonly="readonly"
        :filled="readonly"
        :items="tiposDeCanaisDisponiveis"
        :rules="[validators.select]"
        @change="v => {
          $emit('update:tipoDeCanalSelecionadoId', v)
          handleTipoDeCanalSelecionadoChange()
        }"
      />
    </v-col>

    <v-expand-transition>
      <v-col
        v-if="tipoDeCanalSelecionadoIdLocale"
        cols="6"
      >
        <v-select
          v-model="canalSelecionadoIdLocale"
          dense
          outlined
          validate-on-blur
          label="Nome do Canal de envio"
          placeholder="Canal de envio"
          item-text="nome"
          item-value="id"
          no-data-text="Nenhum canal disponível"
          :clearable="!readonly"
          :readonly="readonly"
          :filled="readonly"
          :loading="getCanaisDisponiveisLoading"
          :items="canaisDisponiveis"
          :rules="[validators.select]"
          @change="v => $emit('update:canalSelecionadoId', v)"
        />
      </v-col>
    </v-expand-transition>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import CanalService from '@/services/modules/CanalService'
import TiposDeCanaisEnum from '@/models/entities/canal/TiposDeCanaisEnum'
import { select } from '@/@core/utils/validation'

export default {
  emits: ['update:tipoDeCanalSelecionadoId', 'update:canalSelecionadoId'],

  props: {
    tipoDeCanalSelecionadoId: {
      type: Number,
      default: null,
    },
    canalSelecionadoId: {
      type: Number,
      default: null,
    },
    handleTipoDeCanalSelecionadoChange: {
      type: Function,
      required: true,
    },
    readonly: Boolean,
  },

  setup(props) {
    const tiposDeCanaisDisponiveis = [
      {
        id: TiposDeCanaisEnum.SMS,
        nome: 'SMS',
      },
      {
        id: TiposDeCanaisEnum.WhatsApp,
        nome: 'WhatsApp',
      },
      {
        id: TiposDeCanaisEnum.Email,
        nome: 'E-mail',
      },
    ]
    const tipoDeCanalSelecionadoIdLocale = ref(null)
    const canaisDisponiveis = ref([])
    const getCanaisDisponiveisLoading = ref(false)
    const canalSelecionadoIdLocale = ref(null)

    watch(
      () => props.tipoDeCanalSelecionadoId,
      v => {
        if (!v) return
        tipoDeCanalSelecionadoIdLocale.value = v
      },
      {
        immediate: true,
      },
    )

    async function getCanais(canalTipoId) {
      if (getCanaisDisponiveisLoading.value) return
      if (!canalTipoId) return

      try {
        getCanaisDisponiveisLoading.value = true
        canaisDisponiveis.value = await CanalService.get(canalTipoId)
      } finally {
        getCanaisDisponiveisLoading.value = false
      }
    }

    watch(tipoDeCanalSelecionadoIdLocale, getCanais, { immediate: true })

    watch(
      () => props.canalSelecionadoId,
      v => {
        if (!v) return
        canalSelecionadoIdLocale.value = v
      },
      {
        immediate: true,
      },
    )

    return {
      tiposDeCanaisDisponiveis,
      tipoDeCanalSelecionadoIdLocale,
      canalSelecionadoIdLocale,
      canaisDisponiveis,
      getCanaisDisponiveisLoading,
      validators: {
        select,
      },
    }
  },
}
</script>
